import { TaxProClientsTable } from './TaxProClientsTable';

export const TaxProClientsView = ({
  mode,
  taxYear,
}: {
  mode: 'active' | 'closed';
  taxYear: number | null;
}) => {
  return (
    <div className="flex flex-col rounded-16 border border-line-card bg-background-card">
      <TaxProClientsTable mode={mode} taxYear={taxYear} />
    </div>
  );
};
